import { combineReducers } from "redux";
import assetRc from "./assetRc/assetRcSlice";
import keyMembers from "./keyMembers/keyMembersSlice";
import division from "./division/divisionSlice";
import assetCategory from "./assetCategory/assetCategorySlice";
import role from "./role/roleSlice";
import admin from "./admin/adminSlice";

export default combineReducers({
	assetRc,
	keyMembers,
	division,
	assetCategory,
	role,
	admin,
});
